import { render, staticRenderFns } from "./activity.vue?vue&type=template&id=67568736&scoped=true&"
import script from "./activity.vue?vue&type=script&lang=js&"
export * from "./activity.vue?vue&type=script&lang=js&"
import style0 from "./activity.vue?vue&type=style&index=0&id=67568736&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67568736",
  null
  
)

export default component.exports